import { fromJS, List } from 'immutable';
import {
  GET_PACKAGES_FOR_ROOM_UPGRADE,
  GET_PACKAGES_FOR_ROOM_UPGRADE_SUCCESS,
  GET_PACKAGES_FOR_ROOM_UPGRADE_FAIL,
} from '../constants/extra-rooms';

import { CLEAR_PREVIOUS_PACKAGE_DATA } from '../constants/similar-packages';

const initialState = fromJS({
  fetching: false,
  data: List(),
  error: null,
  originalPackageId: null,
  isRequestCreated: false,
});

export default function extraRoomsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PACKAGES_FOR_ROOM_UPGRADE:
      return state.set('isRequestCreated', true);
    case GET_PACKAGES_FOR_ROOM_UPGRADE_SUCCESS: {
      const originalPackageId = payload.length ? payload[0].package_id : null;
      return state
        .set('data', fromJS(payload))
        .set('originalPackageId', originalPackageId);
    }
    case GET_PACKAGES_FOR_ROOM_UPGRADE_FAIL:
      return state.set('error', fromJS(payload));
    case CLEAR_PREVIOUS_PACKAGE_DATA:
      return initialState;

    default:
      return state;
  }
}
